import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import { Rnd } from "react-rnd";
import "./css/template.css"; // Import styles

const TemplatePage = () => {
  const [elements, setElements] = useState([]); // Store added elements
  const editorRef = useRef(null);

  // Add Image
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setElements([
        ...elements,
        {
          id: Date.now(),
          type: "image",
          url: imageUrl,
          width: 200,
          height: 200,
          x: 100,
          y: 100,
        },
      ]);
    }
  };

  // Add Text
  const addText = () => {
    setElements([
      ...elements,
      {
        id: Date.now(),
        type: "text",
        content: "New Text",
        color: "#000",
        fontSize: 30,
        fontFamily: "Arial",
        x: 100,
        y: 100,
      },
    ]);
  };

  // Add Shape
  const addShape = () => {
    setElements([
      ...elements,
      {
        id: Date.now(),
        type: "shape",
        shape: "rectangle",
        color: "#3498db",
        width: 150,
        height: 100,
        x: 100,
        y: 100,
      },
    ]);
  };

  // Update Element
  const updateElement = (id, key, value) => {
    setElements((prev) =>
      prev.map((el) => (el.id === id ? { ...el, [key]: value } : el))
    );
  };

  // Delete Element
  const deleteElement = (id) => {
    setElements((prev) => prev.filter((el) => el.id !== id));
  };

  // Download Design
  const downloadDesign = () => {
    html2canvas(editorRef.current, { useCORS: true }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "design.png";
      link.click();
    });
  };

  return (
    <div className="editor-container">
      {/* Sidebar Controls */}
      <div className="sidebar">
        <h3>🎨 Create Your Design</h3>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        <button className="add-btn" onClick={addText}>➕ Add Text</button>
        <button className="add-btn" onClick={addShape}>🔳 Add Shape</button>
        <button className="download-btn" onClick={downloadDesign}>📥 Download</button>
      </div>

      {/* Design Area */}
      <div className="template-area">
        <div ref={editorRef} className="blank-template">
          {elements.map(({ id, type, url, content, color, fontSize, fontFamily, x, y, width, height, shape }) => (
            <Rnd
              key={id}
              default={{ x, y, width, height }}
              bounds="parent"
              enableResizing={true}
              onDragStop={(e, d) => updateElement(id, "x", d.x)}
              onResizeStop={(e, direction, ref) =>
                updateElement(id, "width", parseInt(ref.style.width))
              }
            >
              {type === "image" ? (
                <div className="element-container">
                  <img src={url} alt="User Upload" className="resizable-img" style={{ width, height }} />
                  <button className="delete-btn" onClick={() => deleteElement(id)}>❌</button>
                </div>
              ) : type === "text" ? (
                <div className="element-container">
                  <input
                    type="text"
                    className="text-input"
                    value={content}
                    onChange={(e) => updateElement(id, "content", e.target.value)}
                    style={{ color, fontSize, fontFamily }}
                  />
                  <input type="color" value={color} onChange={(e) => updateElement(id, "color", e.target.value)} />
                  <select onChange={(e) => updateElement(id, "fontFamily", e.target.value)}>
                    <option>Arial</option>
                    <option>Courier New</option>
                    <option>Georgia</option>
                    <option>Verdana</option>
                    <option>Comic Sans MS</option>
                  </select>
                  <button className="delete-btn" onClick={() => deleteElement(id)}>❌</button>
                </div>
              ) : type === "shape" ? (
                <div
                  className="shape"
                  style={{
                    width,
                    height,
                    backgroundColor: color,
                    borderRadius: shape === "circle" ? "50%" : "0",
                  }}
                >
                  <button className="delete-btn" onClick={() => deleteElement(id)}>❌</button>
                </div>
              ) : null}
            </Rnd>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplatePage;
